import { Navigation, Pagination, A11y } from 'swiper/modules'
import { PAGINATION } from '../constants'
import { renderBullet } from '../icons/renderBullet'

export const defaultPreset = {
  modules: [Navigation, Pagination, A11y],
  slidesPerView: 1,
  slidesPerGroup: 1,
  speed: 300,
  watchOverflow: true,
  resistanceRatio: 0.85,
  spaceBetween: 40,
  pagination: {
    clickable: true,
    dynamicBullets: PAGINATION.dynamicBullets,
    dynamicMainBullets: PAGINATION.dynamicMainBullets,
    renderBullet,
  },
}
